import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
} from "@material-ui/core";

import Loading from "./Loading";

import { withStyles } from "@material-ui/styles";
import styles from "./Styles/BookScreenStyles";

import API from "../Services/API";

const ApptTypeSelection = (props) => {
  let { classes } = props;
  const [didInitLoad, setDidInitLoad] = useState(false);
  const [noData, setNoData] = useState("");
  const [loading, setLoading] = useState(false);
  const [call, setCall] = useState(false);
  const api = API.create();
  const [apptTypes, setApptTypes] = useState("");

  useEffect(() => {
    if (props.moveToApptType.newCall) {
      setDidInitLoad(false);
      props.moveToApptType.newCall = false;
    }
    if (!didInitLoad) {
      setLoading(true);
      initialLoad();
    }
  });

  const initialLoad = () => {
    api.getApptType(
      {
        dbname: props.moveToApptType.dbname

      },
      (apptTypeRes) => {
        if (apptTypeRes.status === 200) {
          let apptTypeResObj = apptTypeRes.data;
          if (apptTypeResObj && apptTypeResObj.length > 0 && apptTypeResObj !== 'glaceportal_failure_exception' && apptTypeResObj !== 'no response' && Array.isArray(apptTypeResObj)) {
            const activeApptTypes = apptTypeResObj.filter(
              (apptType) => apptType.app_Reference_Values_isActive === true
            );

            if (activeApptTypes.length === 0) {
              setNoData("true");
            } else {
              setNoData("false");
              setApptTypes(activeApptTypes);
            }

            // Auto select logic if needed
            // if (!call && props.moveToApptType.modes==1 && props.moveToApptType.apptTypeIds!=null) { ... }

            setLoading(false);
            setDidInitLoad(true);
          } else {
            setNoData("true");
            setLoading(false);
            setDidInitLoad(true);
          }
        } else {
          setNoData("true");
          setLoading(false);
          setDidInitLoad(true);
        }
      }
    );
  };

  const apptTypeSelected = (apptType) => {
    props.moveToApptType.apptTypeSelected(
      apptType.app_Reference_Values_statusId,
      apptType.app_Reference_Values_statusName,
      props.moveToApptType.dbname,
      apptType.app_Reference_Values_duration
    );
  };

  return (
    <div>
      {loading && (
        <Loading />
      )}
      {!loading && (
        <Grid container spacing={1} elevation={0} >
          {apptTypes.length === 0 && <Typography variant="p" className={classes.noData}>None</Typography>}
          {apptTypes.length > 0 &&
            Object.keys(apptTypes).map((key, index) => (
              <Grid item md={3} xs={6} className={classes.itemPanelGrid} justify="space-between" key={index}>
                <Card className={classes.itemPanelCard}>
                  <CardActionArea onClick={apptTypeSelected.bind(null, apptTypes[key])}>
                    <CardContent className={classes.contentHover} style={{
                      display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                      <Typography variant="subtitle1" style={{
                        fontSize: 14,
                        color: "#4f4f4f"
                      }}>
                        {(apptTypes[key].app_Reference_Values_statusName || "Unknown")
                          .split(" ")
                          .map(
                            (s) =>
                              s.charAt(0).toUpperCase() +
                              s.substring(1)
                          )
                          .join(" ")}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
        </Grid>
      )}
    </div>
  );
};

export default withStyles(styles)(ApptTypeSelection);

